import React, { useState, useEffect } from 'react';
import { Icon } from '../common/icons';

import { isNullOrWhiteSpace } from '../../helpers/isNullOrWhiteSpace';

export const VideoInfo = ({
    information,
    seekTo
}) => {


  const [ headingTitle, setHeadingTitle ] = useState(1)
  const [ searchValue, setSearchValue ] = useState('')
  const [ videoTimelines, setVideoTimelines ] = useState(information.videos[0].insights.transcript)

  
  useEffect(() => {

    if(!isNullOrWhiteSpace(searchValue)){

      setVideoTimelines(information.videos[0].insights.transcript.filter(t => t.text.search(searchValue) !== -1))
    }

  }, [searchValue])

  const goToTime = time => {

    const timeSplit = time.split(":")
    const seconds = parseInt(timeSplit[0],10) * 60 * 60 + parseInt(timeSplit[1],10) * 60 + parseInt(timeSplit[2],10)

    seekTo(seconds)
  }

  const handleSearchChange = e => {

    const { value } = e.currentTarget;
    setSearchValue(value)
  }

  


    return(

        <div className="gpt-message__product--video-info">

          <div className="gpt-message__product--video-headings">
            <div className={headingTitle === 1 ? "ai-body-medium bold ai-grey-100 gpt-message__product--video-headings-active": "ai-body-medium ai-grey-100"} onClick={() => setHeadingTitle(1)}>Timeline</div>
            {/* <div className={headingTitle === 2 ? "ai-body-medium bold ai-grey-100 gpt-message__product--video-headings-active": "ai-body-medium ai-grey-100"} onClick={() => setHeadingTitle(2)}>Insights</div> */}
          </div>

        
            <div className="gpt-message__product--video-timeline">
              <div className="gpt-message__product--video-timeline-search">
                <Icon name="search" customClass="icon--medium"/>
                <input type='text' 
                  placeholder={`Search`}
                  className={`library__search--field ai-body-medium ai-grey-100`}
                  onChange={event => handleSearchChange(event)} 
                  // onKeyDown={event => handleKeyPress(event)}
                  // onClick={event => handlePublicSearchOnChangeClick(event)}
                  name='search' 
                  autoComplete={`off`}
                  value={searchValue} 
                  // spellCheck={true}
                  />

              </div>
              {videoTimelines.map(t => {

                return(
                  <div key={t.id} onClick={() => goToTime(t.instances[0].start)}>
                    <div className="ai-body-tiny ai-grey-100">{t.instances[0].start.split(".")[0]}</div>
                    <div className="ai-body-medium ai-grey-100">{t.text}</div>


                  </div>
                )
              })}

            </div>
      


        </div>
      
    )


}